import { z } from 'zod';
import { viteApiBaseUrl } from '../constants/env';
const ApiConfig = z.object({
    baseApiUrl: z.string().url(),
});
/**
 * This is a workaround for fetching the existing base URL from our environment variables.
 * Our ts-rest contracts provide the full api url path, so we must do it this way.
 */
export const apiConfig = () => {
    const baseApiUrl = viteApiBaseUrl();
    return ApiConfig.parse({
        baseApiUrl,
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBpLmNvbmZpZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hcGkvYXBpLmNvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsQ0FBQyxFQUFFLE1BQU0sS0FBSyxDQUFDO0FBQ3hCLE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSxrQkFBa0IsQ0FBQztBQUVsRCxNQUFNLFNBQVMsR0FBRyxDQUFDLENBQUMsTUFBTSxDQUFDO0lBQ3pCLFVBQVUsRUFBRSxDQUFDLENBQUMsTUFBTSxFQUFFLENBQUMsR0FBRyxFQUFFO0NBQzdCLENBQUMsQ0FBQztBQUtIOzs7R0FHRztBQUNILE1BQU0sQ0FBQyxNQUFNLFNBQVMsR0FBRyxHQUFjLEVBQUU7SUFDdkMsTUFBTSxVQUFVLEdBQUcsY0FBYyxFQUFFLENBQUM7SUFDcEMsT0FBTyxTQUFTLENBQUMsS0FBSyxDQUFDO1FBQ3JCLFVBQVU7S0FDWCxDQUFDLENBQUM7QUFDTCxDQUFDLENBQUMifQ==